module.exports = fox._r("fonts/kreon-regular-webfont.svg", __webpack_public_path__ + "_/_/_/common/frame/fonts/kreon-regular-webfont.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/kreon-regular-webfont.svg
// module id = 104
// module chunks = 2